<template lang="pug">
  .income
    v-container.px-0(:class="isPrinting? 'py-0' : ''" style="max-width:800px")
      PickList(fill-width :pid="pid")

</template>

<script>
import PickList from '@/components/ordermgmt/PickList.vue'

export default {
  name: 'YezzaPickList',
  props: ['pid'],
  components: { PickList },
  computed: {
    isPrinting () {
      if (this.$route.path.includes('print-pick-list')) {
        return true
      }
      return false
    }
  },
  data: () => ({
  })
}
</script>

<style lang="scss" scoped>
</style>


<style scoped>
</style>
